import PurchaseOrder from './PurchaseOrder.gql';

export default PurchaseOrder;
